import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import { getSortedTypes, initialAppointmentTypeFilter } from "./FilterTypes/AppointmentTypeFilterType";
import { FilterContext } from "../FilterContext";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

const AppointmentTypeFilter = () => {
  const title = RESX.GeneralLabels.Type;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("appointmentType", {
    getTitle: () => title,
    renderSelection: (filter) => <div>
      {getSortedTypes(filter)
        .map(type => <span key={type.value} className={`${type.icon} margin-right`} title={type.text} />)}
    </div>,
    hasValue: (filter) => filter.selectedTypes.length > 0,
    reset: () => initialAppointmentTypeFilter,
    areEqual: (a, b) => a.selectedTypes.length === b.selectedTypes.length && a.selectedTypes.every((type, index) => type.value === b.selectedTypes[index].value)
  });
  useEffect(() => {
    setInitialValue("appointmentType", initialAppointmentTypeFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedTypes, setSelectedTypes] = React.useState(initialAppointmentTypeFilter.selectedTypes);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedTypes(getValue("appointmentType").selectedTypes);
    setPopupOpen(true);
  };

  const onTypeToggle = (newType: server.dto.AppointmentType) => {
    const isSelected = selectedTypes.some(p => p.value === newType.value);
    const newSelection = isSelected
      ? selectedTypes.filter(p => p.value !== newType.value)
      : [...selectedTypes, newType];
    setSelectedTypes(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("appointmentType", { selectedTypes });
    setPopupOpen(false);
  };
  const checkedMap = new Set(selectedTypes.map(p => p.value));

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<>
        <div className="margin-bottom flex-column gap-small">
          {serverReference.appointmentTypes.filter(type => type.value !== "accommodation").map((type, index) =>
            <AppointmentTypeRow
              autoFocus={index === 0}
              key={type.value}
              type={type}
              checked={checkedMap.has(type.value)}
              onToggle={() => { onTypeToggle(type); }} />
          )}
        </div>

        <Button fluid onClick={onApply} primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

const AppointmentTypeRow = ({ autoFocus, type, checked, onToggle }: { autoFocus?: boolean, type: server.dto.AppointmentType, checked: boolean, onToggle: () => void }) => (
  <div>
    <Checkbox
      autoFocus={autoFocus}
      keyboardNavigationOptions={VerticalKeyboardNavigationGroup("appointmentTypes")}
      onChange={onToggle}
      checked={checked}
      label={<div className="inline-flex">
        <div style={{ width: 23 }}>
          <i className={type.icon} />
        </div>
        <span className="padding-left-small">{type.text}</span>
      </div>} />
  </div>
);

export default AppointmentTypeFilter;